export default __webpack_public_path__ + "static/faq-image-a5000c90bcb14509df2e67d2200b9e53.svg";